import { Outlet } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { CycleStatusesFeatureDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { Loading } from 'modules/compensations/components/loading'
import { useCyclesListFilterOptions } from 'modules/compensations/hooks/useCyclesListFilterOptions'
import { isFeatureEnabled } from 'modules/compensations/lib/utils'
import { CyclesList } from 'modules/compensations/pages/CyclesList'
import CycleStatusLaunchModal from './CycleStatusLaunchModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CyclesPage = () => {
  const { company } = useCurrentSession()

  const {
    countryFilterOptions,
    currencyFilterOptions,
    loading: loadingFilterOptions,
  } = useCyclesListFilterOptions()

  const { data: featuresData } = useQuery(CycleStatusesFeatureDocument, {
    variables: { companyId: company.id },
  })

  const isPayrollRunTimelineFeatureEnabled = isFeatureEnabled(
    'dev_compensations_payrollrun_timeline',
    featuresData?.features?.featuresConnection
  )

  const canEditCompensationConcepts =
    featuresData?.compensations?._policies?.payrollConceptsEdit?.can ?? false

  if (loadingFilterOptions) {
    return <Loading />
  }

  return (
    <ResponsivePage.Body height="none">
      <CycleStatusLaunchModal
        canEditCompensationConcepts={canEditCompensationConcepts}
        isPayrollRunTimelineFeatureEnabled={isPayrollRunTimelineFeatureEnabled}
      />
      <CyclesList
        countryFilterOptions={countryFilterOptions}
        currencyFilterOptions={currencyFilterOptions}
        isPayrollRunTimelineFeatureEnabled={isPayrollRunTimelineFeatureEnabled}
      />
      <Outlet
        context={{
          countryFilterOptions,
          currencyFilterOptions,
        }}
      />{' '}
    </ResponsivePage.Body>
  )
}

export default CyclesPage
